<tf-shared-list-loading *ngIf="showLoading"></tf-shared-list-loading>

<div *ngIf="showListsContainer">

    <tf-shared-list-not-logged-in *ngIf="!isLoggedIn()"></tf-shared-list-not-logged-in>

    <div *ngIf="isLoggedIn()">

        <div class="existing-shared-list">
            <div *ngIf="shareList">
                <ul>
                    <li class="each-list-dimensions"
                        *ngFor="let listItem of shareList; index as listItemKey "
                        (click)="addToExistingSharedList($event,listItem)">
                        <div class="list-item-wrapper">
                            <span *ngIf="!listItem.collaborative" class="no-collaborators-icon"></span>
                            <span *ngIf="listItem.collaborative" class="collaborators-icon"></span>
                            <span class="list-name">{{listItem.listName}}</span>
                        </div>
                    </li>
                </ul>
            </div>
            <div *ngIf="!shareList">
                <div class="create-first-list-section">
                    <div style="font-size: 18px; margin-top: 10px;" align="center">
                        <span>No List</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="add-new-shared-list">
            <input type="text"
                   name="create-new-list"
                   class="create-new-list-text"
                   placeholder="Add a new list"
                   maxlength="150"
                   [(ngModel)]="newListName"/>
            <button type="button"
                    class="btn btn-secondary btn-create-new-list"
                    (click)="addToNewSharedList($event)">
                Create
            </button>
        </div>

    </div>

</div>
